import { Apis } from "libs/apis"
import { dispatch } from "store"
import { setModalClosed } from "store/user-slice"

export const useIngredientDetail = () => {
    const postIngredientDetail =async (body:FormData) => {
        await  Apis.postIngredientDetail(body)
        .then((res) => {
            if(res.data?.status){
                dispatch(setModalClosed('Ingredient Detail'))
            }
        })
        .catch((err) => console.error(err))
    }

    const putIngredientDetail =async (id:number , body:FormData) => {
        await Apis.putIngredientDetail(id , body)
        .then((res) => {
            if(res?.data?.status){
                dispatch(setModalClosed('Ingredient Detail'))
            }
        })
        .catch((err) => console.error(err))
    }

    const getIngredientDetail =async (setData:any) => {
        await Apis.getIngredientDetail()
        .then((res) => {
            setData(res.data.data)
        })
        .catch((err) => console.error(err))
    }

    const getIngredientDetailById =async (id:number , setData:any) => {
        await Apis.getIngredientDetailById(id)
        .then((res) => {
            setData(res?.data?.data)
        })
        .catch((err) => console.error(err))
    }

    const deleteIngredientDetail =async (id:number) => {
        await Apis.deleteIngredientDetail(id)
        .then((res) => console.error(res))
        .catch((err) => console.error(err))
    }

    return { postIngredientDetail , putIngredientDetail , getIngredientDetail , getIngredientDetailById , deleteIngredientDetail}
}